// @ts-nocheck
/* eslint-disable */
import { useMatches, useParams, useNavigate } from 'react-router-dom'
import { useAuth, useGuard, useHasAccess } from '../../hooks/auth'
import { LOCAL_EXECUTION } from '../../utils/featureFlag'
import {
  DashboardhMediumButton,
  DashboardMessage,
  DashboardFinancialCloseHeader,
  DashboardFinancialDropdown,
  Table,
  DashboardTransactionItem,
  DashboardFinancialLink,
  Modal,
  DashboardAlertMessage,
} from 'bd-web-components'
import {
  Container,
  PixelLogo,
  FormDivider,
  TextHeaderBox,
  PageTitle,
  PageHeaderBox,
  PageSubtitle,
  ButtonHeaderBox,
  TableContainer,
  ExceptionContainer,
  LoaderBox,
  TableTag,
  Button,
  FinancialClosingButtons,
  StyledForm,
  GridForm,
  OwnerBox,
  FacebookBox,
  GoogleBox,
  SaveButtonBox,
  GoogleAdsBox,
  TikTokBox,
  CancelButtonBox,
  TagTitle,
  TagTitleBox,
  PixelRow,
  PixelRowFirstLine,
  PixelRowSecondLine,
  PixelRowSecondLineFields,
  AddPixelButtonWrap,
  AddPixelButton,
  RemovePixelButtonWrap,
  RemovePixelButton,
} from './styles'
import { useCallback, useEffect, useState } from 'react'
import {
  PRIMARY_RED_03,
  SECONDARY_BLUE_01,
  SECONDARY_GREEN_07,
} from 'bd-web-components/src/utils/dash-colors'
import Loader from '../../components/Loader'
import {
  useApproveReject,
  useFinancialClosing,
} from '../../hooks/financial-close'
import { useFinancialClosingTransactions } from '../../hooks/financial-close-transactions'
import { TransactionItemModal } from '../../components/FinancialTransactionItem'
import currencyFormatter from 'currency-formatter'
import { useFinancialClosingDebits } from '../../hooks/financial-close-debits'
import { useFinancialClosingAdjustments } from '../../hooks/financial-close-adjustments'
import { DropdownContainer } from '../../components/DropdownContainer'
import { useEvent } from '../../hooks/events'
import { useFormik } from 'formik'
import FormikField from '../../components/Field'
import { useGetTrackerIds } from '../../hooks/tracker-ids'
import { useBoolean } from '../../hooks/use-boolean'
import useSWRMutation from 'swr/mutation'
import {
  TrackerData,
  TrackerPayload,
  useTrackerUpdate,
  GoogleAdsPixelItem,
} from '../../hooks/tracker-update'
import { toast } from 'react-toastify'
import meta from '../../assets/pixel/meta.svg'
import tiktok from '../../assets/pixel/tiktok.svg'
import gads from '../../assets/pixel/g_ads.svg'
import ganalytics from '../../assets/pixel/g_analytics.svg'
import { Breadcrumb } from '../../components/Breadcrumb'
import useBdApp from '../../hooks/bdapp/useBdApp'

export function Pixel() {
  // -----------------------------------------------------
  const authContext = useAuth()
  const { isNative } = useBdApp()
  const { id } = useParams<{ id: string }>()
  const eventId = Number(id)
  const { event } = useEvent(Number(id))
  const { authHookWithEvent } = authContext
  const navigate = useNavigate()

  if (!LOCAL_EXECUTION) {
    authHookWithEvent(id!, navigate)
  }

  // verify if user has permission to acess
  useGuard(['DP8'])

  // -----------------------------------------------------
  const screenLimit = 762

  let matches = useMatches()
  let crumbs = matches
    .filter((match: any) => Boolean(match.handle?.crumb))
    .map((match: any) => {
      return {
        name: match.handle.crumb(match.data),
        path: match.pathname,
      }
    })

  const { tracker, trackerError, trackerLoading } = useGetTrackerIds(id)

  const emptyGoogleAdsPixel = (): GoogleAdsPixelItem => ({
    value: '',
    convertion_id: '',
    label: '',
  })

  const initialValues: TrackerData = {
    facebook: '',
    google: '',
    google_ads: [emptyGoogleAdsPixel()],
    tiktok: '',
  }

  const [initial, setInitial] = useState(initialValues)

  const loading = useBoolean()
  const edit = useBoolean()

  const { fetcher } = useTrackerUpdate()

  const useFormikProps = useFormik({
    enableReinitialize: true,
    initialValues: initial,
    onSubmit: async (
      values: TrackerData,
      { setSubmitting, resetForm }: any
    ) => {
      loading.onTrue()
      const payload: TrackerPayload = {
        ...useFormikProps.values,
        event_id: id,
      }
      try {
        await fetcher(payload)
        loading.onFalse()
        edit.onFalse()
        toast.success('Ids de rastreamento atualizados com sucesso!')
      } catch (error) {
        toast.error('Um erro aconteceu, tente novamente!')
        loading.onFalse()
        edit.onFalse()
      }
    },
  })

  useEffect(() => {
    if (tracker.tracker !== undefined) {
      if (tracker.tracker.length !== 0) {
        const trackerArray = Array.isArray(tracker.tracker) ? tracker.tracker : []

        const result: TrackerData = {
          facebook: '',
          google: '',
          google_ads: [],
          tiktok: '',
        }

        trackerArray.forEach((item: any) => {
          const { api, value } = item
          if (api === 'google_ads') {
            if (Array.isArray(value)) {
              value.forEach((pixel: any) => {
                result.google_ads.push({
                  value: pixel?.value ?? '',
                  convertion_id: pixel?.convertion_id ?? '',
                  label: pixel?.label ?? '',
                })
              })
            } else if (typeof value === 'string') {
              result.google_ads.push({
                value: value ?? '',
                convertion_id: '',
                label: '',
              })
            }
          } else if (result[api as keyof TrackerData] !== undefined && typeof result[api as keyof TrackerData] === 'string') {
            ;(result as any)[api] += `${value};`
          }
        })

        if (result.google_ads.length === 0) {
          result.google_ads = [emptyGoogleAdsPixel()]
        }
        setInitial(result)
      }
    }
  }, [tracker, trackerError, trackerLoading])
  return (
    <>
      <Container>
        <Breadcrumb
          paths={[
            { name: 'Início', path: '/events' },
            { name: 'Evento', path: `/events/${id}` },
            ...crumbs,
          ]}
        />
        <>
          <PageHeaderBox>
            <TextHeaderBox>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'flex-start',
                  width: '100%',
                  marginTop: isNative ? '0px' : '40px',
                  marginBottom: '10px',
                  height: 'max-content',
                }}
              >
                <PageTitle>Gerenciamento de Tags/Pixels</PageTitle>
              </div>
              <PageSubtitle>
                Gerencie os pixels de rastreamento para monitorar e otimizar seu
                evento.
                <br />
                <br />
                Para Meta, TikTok e GA4: múltiplos IDs podem ser inseridos no
                mesmo campo separados por ponto e vírgula ";". Exemplo:
                12345;67890;11223
                <br />
                <br />
                Para Google ADS: cada pixel possui ID da TAG, Conversion ID e
                Label. Use &quot;Adicionar novo pixel&quot; para cadastrar mais de um.
              </PageSubtitle>
            </TextHeaderBox>
            <ButtonHeaderBox></ButtonHeaderBox>
          </PageHeaderBox>
          <FormDivider />
        </>
        <div>
          {/* ERROR CASE */}
          {trackerError && (
            <ExceptionContainer height={400} margin={false}>
              <DashboardMessage
                isError={true}
                isImage={true}
                maintext={'Um erro aconteceu...'}
                subtext={'Já estamos trabalhando para corrigir o problema'}
              />
            </ExceptionContainer>
          )}
          {/* LOADING CASE */}
          {trackerLoading && (
            <ExceptionContainer height={400} margin={false}>
              <Loader />
            </ExceptionContainer>
          )}
          {/* SUCCESS CASE */}
          {tracker && !trackerLoading && !trackerError && (
            <StyledForm onSubmit={useFormikProps.handleSubmit}>
              <GridForm>
                <FacebookBox>
                  <TagTitleBox>
                    <PixelLogo src={meta} alt="meta-logo" />
                    <TagTitle>Meta</TagTitle>
                  </TagTitleBox>
                  <FormikField
                    formikFieldType={'input'}
                    inputType={'text'}
                    name={'facebook'}
                    disabled={!edit.value}
                    useFormik={useFormikProps}
                    title={'ID do Pixel do Facebook'}
                    inputPlaceholder={'Exemplo: "2256765871372467"'}
                    maxLength={300}
                  />
                </FacebookBox>
                <TikTokBox>
                  <TagTitleBox>
                    <PixelLogo src={tiktok} alt="meta-logo" />
                    <TagTitle>TikTok</TagTitle>
                  </TagTitleBox>
                  <FormikField
                    formikFieldType={'input'}
                    inputType={'text'}
                    name={'tiktok'}
                    disabled={!edit.value}
                    useFormik={useFormikProps}
                    title={'ID do Pixel do TikTok'}
                    inputPlaceholder={'Exemplo: "CSGDME3C77U3K05HE15G"'}
                    maxLength={300}
                  />
                </TikTokBox>
                <GoogleBox>
                  <TagTitleBox>
                    <PixelLogo src={ganalytics} alt="meta-logo" />
                    <TagTitle>GA4</TagTitle>
                  </TagTitleBox>
                  <FormikField
                    formikFieldType={'input'}
                    inputType={'text'}
                    name={'google'}
                    disabled={!edit.value}
                    useFormik={useFormikProps}
                    title={'ID da TAG'}
                    inputPlaceholder={'Exemplo: "G-3TF6KD3CWK"'}
                    maxLength={300}
                  />
                </GoogleBox>
                <GoogleAdsBox>
                  <TagTitleBox>
                    <PixelLogo src={gads} alt="meta-logo" />
                    <TagTitle>Google ADS</TagTitle>
                  </TagTitleBox>
                  {(useFormikProps.values.google_ads ?? []).map((_, index) => (
                    <PixelRow key={index}>
                      <PixelRowFirstLine>
                        <FormikField
                          formikFieldType={'input'}
                          inputType={'text'}
                          name={`google_ads[${index}].value`}
                          disabled={!edit.value}
                          useFormik={useFormikProps}
                          title={'ID da TAG'}
                          inputPlaceholder={'Exemplo: "AW-1003884611"'}
                          maxLength={300}
                        />
                      </PixelRowFirstLine>
                      <PixelRowSecondLine>
                        <PixelRowSecondLineFields>
                          <FormikField
                            formikFieldType={'input'}
                            inputType={'text'}
                            name={`google_ads[${index}].convertion_id`}
                            disabled={!edit.value}
                            useFormik={useFormikProps}
                            title={'Conversion ID'}
                            inputPlaceholder={'Conversion ID'}
                            maxLength={300}
                          />
                          <FormikField
                            formikFieldType={'input'}
                            inputType={'text'}
                            name={`google_ads[${index}].label`}
                            disabled={!edit.value}
                            useFormik={useFormikProps}
                            title={'Label'}
                            inputPlaceholder={'Label'}
                            maxLength={300}
                          />
                        </PixelRowSecondLineFields>
                        {edit.value && index > 0 && (
                          <RemovePixelButtonWrap>
                            <RemovePixelButton
                              type="button"
                              onClick={() => {
                                const next = useFormikProps.values.google_ads.filter((_, i) => i !== index)
                                useFormikProps.setFieldValue('google_ads', next.length ? next : [emptyGoogleAdsPixel()])
                              }}
                            >
                              Remover
                            </RemovePixelButton>
                          </RemovePixelButtonWrap>
                        )}
                      </PixelRowSecondLine>
                    </PixelRow>
                  ))}
                  {edit.value && (
                    <AddPixelButtonWrap>
                    <AddPixelButton
                      type="button"
                      onClick={() => {
                        useFormikProps.setFieldValue('google_ads', [
                          ...(useFormikProps.values.google_ads ?? []),
                          emptyGoogleAdsPixel(),
                        ])
                      }}
                    >
                      Adicionar novo pixel
                    </AddPixelButton>
                    </AddPixelButtonWrap>
                  )}
                </GoogleAdsBox>
                <CancelButtonBox full={!edit.value}>
                  {!edit.value && (
                    <DashboardhMediumButton
                      onClick={edit.onTrue}
                      background=""
                      color=""
                      height="52px"
                      maxWidth="100%"
                      variant={loading.value ? 'disabled' : 'contained'}
                    >
                      Editar
                    </DashboardhMediumButton>
                  )}
                </CancelButtonBox>
                {edit.value && (
                  <SaveButtonBox full={!edit.value}>
                    <DashboardhMediumButton
                      //@ts-ignore
                      type="submit"
                      //@ts-ignore
                      disable={loading}
                      background={SECONDARY_BLUE_01}
                      color=""
                      height="52px"
                      maxWidth="100%"
                      variant={loading.value ? 'disabled' : 'contained'}
                    >
                      {!loading.value && <>{'Atualizar Chaves'}</>}
                      {loading.value && <Loader small={true} />}
                    </DashboardhMediumButton>
                  </SaveButtonBox>
                )}
                {edit.value && (
                  <CancelButtonBox>
                    <DashboardhMediumButton
                      onClick={edit.onFalse}
                      background=""
                      color=""
                      height="52px"
                      maxWidth="100%"
                      variant={'outlined'}
                    >
                      {'Cancelar'}
                    </DashboardhMediumButton>
                  </CancelButtonBox>
                )}
              </GridForm>
            </StyledForm>
          )}
        </div>
      </Container>
    </>
  )
}
